import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Grid, Paper, TextField } from "@mui/material";
import { observer } from "mobx-react";
import SaveIcon from "@mui/icons-material/Save";
import { Link, useNavigate } from "react-router-dom";

function AddCatalog() {
  return observer(() => {
    return (
      <>
        <Grid
          container
          justifyContent={"space-between"}
          paddingX={2}
          paddingTop={2}
        >
          <Link to={"/MasterData/CatalogType"}>
            <div className="inline-block mx-2 text-blue-600 h cursor-pointer">
              <ArrowBackIcon className="!text-sm !mr-2 " />
              Quay lại
            </div>
          </Link>
          <div className="flex space-x-2">
            <Button className="!bg-blue-600 !text-white !items-center">
              <SaveIcon className="!text-lg mr-1 leading-0" />
              Lưu
            </Button>
            <Button className="!bg-blue-600 !text-white !items-center">
              <SaveIcon className="!text-lg mr-1 leading-0" />
              Lưu và tiếp tục
            </Button>
          </div>
        </Grid>
        <Paper className="my-4 mx-4 overflow-hidden">
          <h3 className="p-3 font-bold border-t-2 border-cyan-600">
            LOẠI DANH MỤC
          </h3>
          <Grid
            container
            justifyContent={"space-between"}
            px={4}
            py={2}
            borderTop={1}
            borderColor={"#ccc"}
          >
            <div className="flex flex-col flex-1">
              <label className="mr-5 font-bold text-gray-700 text-sm tracking-wide  ">
                Loại danh mục
              </label>
              <TextField
                inputProps={{
                  style: {
                    padding: 6,
                    minWidth: 320,
                    position: "relative",
                    borderRadius: "2px !important",
                  },
                }}
                className="[&>div]:!rounded-none "
              />
            </div>
            <div className="flex flex-col flex-1 lg:ml-10 md:ml-5 xl:ml-10 sm:ml-0">
              <label className="mr-5 font-bold text-gray-700 text-sm tracking-wide ">
                Tên loại danh mục
              </label>
              <TextField
                inputProps={{
                  style: {
                    padding: 6,
                    minWidth: 320,
                    position: "relative",
                    borderRadius: "2px !important",
                  },
                }}
                className="[&>div]:!rounded-none "
              />
            </div>
          </Grid>
        </Paper>
      </>
    );
  });
}

export default AddCatalog;
